const MODULE_ID = 'begleitfahrt';
export default MODULE_ID;